<template>
  <div>
    <div class="card">
      <div class="card-header card-no-border">
        <h5>Target vs Achievement (MTD) - SKU Wise</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row m-0 overall-card overview-card">
          <div class="col-xl-9 col-md-8 col-sm-7 p-0 box-col-7">
            <div class="chart-right">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card-body p-0">
                    <div class="current-sale-container order-container">
                      <div class="overview-wrapper">
                        <!-- Show loading spinner while data is being fetched -->
                        <div v-if="loading" class="spinner-container">
                          <div class="spinner"></div>
                        </div>

                        <div v-else-if="targetStatus === '0'" class="approval-container">
  <div class="approval-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
         stroke="#7064F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  </div>
  <p class="approval-title">Pending Approval</p>
  <p class="approval-message">
    Targets are currently under the approval process.<br/>
    The chart will be available once targets are approved.
  </p>
</div>
                        <!-- Display chart once data has loaded -->
                        <apexchart
                            v-else
                            height="320"
                            type="bar"
                            :options="ecomDashboard.options2"
                            :series="ecomDashboard.series2"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side Summary Cards -->
          <div class="col-xl-3 col-md-4 col-sm-5 p-0 box-col-5">
            <div class="row g-sm-3 g-2">
              <div class="col-md-12" v-for="item in orderOverview" :key="item.title">
                <div :class="['light-card', 'balance-card', 'widget-hover', 'count-card', item.colorClass]">
                  <div class="svg-box">
                    <svg class="svg-fill">
                      <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#${item.svgIcon}`"></use>
                    </svg>
                  </div>
                  <div>
                    <span class="f-light text-light">{{ item.title }}</span>
                    <h5 class="mt-1 mb-0 text-dark">{{ item.overviewInNumber }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Summary Cards -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { skuWiseTargetVsAchievement } from "@/services/dataService"; // Import API service

export default {
  data() {
    return {
      orderOverview: [
        {
          svgIcon: "orders",
          title: "",
          overviewInNumber: "",
          colorClass: "bg-red"
        },
        {
          svgIcon: "profit",
          title: "",
          overviewInNumber: "",
          colorClass: "bg-green"
        },
        {
          svgIcon: "new-order",
          title: "Active SKUs",
          overviewInNumber: "",
          colorClass: "bg-blue"
        }
      ],
      ecomDashboard: {
        options2: {
          chart: {
            type: "bar",
            height: 320,
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "35%",
              borderRadius: 3
            }
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: [], // SKU Names from API
            labels: {
              rotate: -45,
              style: { fontSize: "12px" }
            },
            title: { text: "SKU" },
          },
          yaxis: {
            title: { text: "Volume (MT)" },
            style: { fontSize: "12px" },
            min: 0
          },
          colors: ["#7064F5", "#54BA4A"],
          legend: {
            position: "top",
            horizontalAlign: "center"
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          grid: {
            show: true,
            borderColor: "var(--chart-border)"
          }
        },
        series2: [
          { name: "Target", data: [] },
          { name: "Achievement", data: [] }
        ]
      },
      loading: true,
      targetStatus: null,
    };
  },
  computed: {
    currentMonthYear() {
      const date = new Date();
      const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
      const year = date.getFullYear();
      return `${month} ${year}`;
    }
  },
  created() {
    this.updateOrderOverviewTitles();
    this.fetchTargetVsAchievementData();
  },
  methods: {
    updateOrderOverviewTitles() {
      this.orderOverview[0].title = `Target (${this.currentMonthYear}) - MT`;
      this.orderOverview[1].title = `Achievement (${this.currentMonthYear}) - MT`;
    },
    async fetchTargetVsAchievementData() {
      const profileId = localStorage.getItem("profile_id");
      const token = localStorage.getItem("token_set");

      try {
        const response = await skuWiseTargetVsAchievement(profileId, token);


        this.targetStatus = response.data.target_status ?? null;
     if (this.targetStatus === '1') { 
        if (response.data && response.data.data) {
          const apiData = response.data.data;
          this.mapApiResponseToChart(apiData);

          // Extract total values
          const totalData = response.data.total[0];
          const totalTarget = parseFloat(totalData.target);
          const totalAchievement = parseFloat(totalData.achievement);
          const itemCount = parseInt(totalData.active_sku_count, 10);

          this.orderOverview[0].overviewInNumber = totalTarget.toLocaleString();
          this.orderOverview[1].overviewInNumber = totalAchievement.toLocaleString();
          this.orderOverview[2].overviewInNumber = itemCount.toLocaleString();
        }
     }
      } catch (error) {
        console.error("Error fetching Target vs Achievement data:", error);
      } finally {
        this.loading = false;
      }
    },
    mapApiResponseToChart(apiData) {
      // Filter only items with target > 0 and take the first 4
      const filteredData = apiData
          .filter(item => parseFloat(item.target) > 0)
          .slice(0, 4);

      // Update categories (X-axis) with filtered SKUs
      this.ecomDashboard.options2.xaxis.categories = filteredData.map(item => item.item);

      // Update series data for Target and Achievement
      this.ecomDashboard.series2 = [
        {
          name: "Target",
          data: filteredData.map(item => parseFloat(item.target))
        },
        {
          name: "Achievement",
          data: filteredData.map(item => parseFloat(item.achievement))
        }
      ];
    }
  }
};
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 320px;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #7064F5;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.bg-red {
  background-color: #7064F5;
}

.bg-green {
  background-color: #54BA4A;
}

.bg-blue {
  background-color: #f4b400;
}

.approval-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 320px;
  gap: 10px;
}

.approval-title {
  font-size: 16px;
  font-weight: 700;
  color: #7064F5;
  margin: 0;
}

.approval-message {
  font-size: 13px;
  font-weight: 400;
  color: #888;
  text-align: center;
  line-height: 1.6;
  margin: 0;
}
</style>